import { Link, useLocation } from "react-router-dom";
import { CalendarHeart } from "lucide-react";

// CTA di contatto sempre raggiungibile su mobile.
export const MobileContactBar = () => {
  const { pathname } = useLocation();
  if (pathname === "/contatti") return null;
  return (
    <div className="lg:hidden fixed bottom-4 inset-x-4 z-40" data-testid="mobile-contact-bar">
      <Link
        to="/contatti"
        className="flex items-center justify-center gap-2 w-full rounded-full bg-sage text-cream py-4 text-sm font-medium shadow-[0_10px_30px_rgb(92,107,88,0.35)] active:scale-[0.98] transition-transform"
        data-testid="mobile-contact-cta"
      >
        <CalendarHeart size={18} />
        Richiedi un primo colloquio
      </Link>
    </div>
  );
};
